export interface RadioStation {
  id: string;
  /** Short text on the lamp button. */
  label: string;
  /** Full broadcaster name, exposed as the desktop tooltip and accessible name. */
  name: string;
  url: string;
  homepage: string;
}

/**
 * The primary broadcaster behind each of LoTRRisk's five jukebox keys. Archon3D deliberately
 * has no station chains or relay: one lamp is one direct HTTPS stream.
 */
export const RADIO_STATIONS: readonly RadioStation[] = [
  {
    id: 'fantasy',
    label: 'FANTASY',
    name: 'Radio Rivendell',
    url: 'https://play.radiorivendell.com/radio/8000/radio.mp3',
    homepage: 'https://www.radiorivendell.com/',
  },
  {
    id: 'rock',
    label: 'ROCK-USA',
    name: '181.FM Rock 40',
    url: 'https://listen.181fm.com/181-rock40_128k.mp3',
    homepage: 'https://www.181.fm/',
  },
  {
    id: 'country',
    label: 'COUNTRY',
    name: '181.FM Highway 181',
    url: 'https://listen.181fm.com/181-highway_128k.mp3',
    homepage: 'https://www.181.fm/',
  },
  {
    id: 'eighties',
    label: '80s-DISCO',
    name: "1.FM Disco Ball 70's-80's",
    url: 'https://strm112.1.fm/disco_mobile_mp3',
    homepage: 'https://www.1.fm/',
  },
  {
    id: 'sweden',
    label: 'SWEDEN',
    name: 'SR P4 Göteborg',
    url: 'https://live1.sr.se/p4gbg-mp3-96',
    homepage: 'https://sverigesradio.se/p4goteborg',
  },
] as const;
